<script>
/*jshint esversion: 6 */
import { computed, watch, toRef, inject} from 'vue';
import './../func.common';
import { FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import { isFunction, isNil} from 'lodash';

export default{
    name: 'CheckboxList',
    components: {
        'font-awesome-icon' : FontAwesomeIcon
    },
    props: {
        'disabled': {type: Boolean},
        'hinted': {type:String},
        'id': { type: String, default: ''}, 
        'model': { type: [Object], default: function() { return {};} }, 
        'schema': { type: [Object], default: function() { return {};} }, 
        'schemaId': {type: Number, default: 0}, 
    },
    setup(props) {
        const validateChild = inject('validateChild');
        const buttonFunctionParent = inject('buttonFunctionParent');
        const helperName = computed(() => {
            return props.model[props.schema.model];
        });

        const vueModel = toRef(props);

        watch(() => helperName, (newVal, oldVal) => {
            var toParent = {
                'id': props.schemaId,
                'model': props.schema.model,
                'validator': props.schema.validator
            };
            if (validateChild) {
                validateChild(toParent);
            }
        }, { deep: true});
        
        function onChanged(event, item) {
            if (event.target.checked === true) {
                props.model[props.schema.model].push(item.id);
            } else {
                var fileType = props.model[props.schema.model]
                var indexFile = fileType.indexOf(item.id);
                fileType.splice(indexFile, 1);
            }
        }

        function isInModel(itemId) {
            var fileType = props.model[props.schema.model];
            if (fileType !== undefined) {
                if (fileType.includes(""+itemId+"") || fileType.includes(itemId)) {
                    return true;
                } else {
                    return false
                }
            } else {
                return false;
            }
        }

        function buttonClick(getfunction) {
            var toParent = {
                'id': props.schemaId,
                'functionVal': getfunction.functionVal,
                'argumentsVal': getfunction.argumentsVal
            };
            if (buttonFunctionParent) {
                buttonFunctionParent(toParent);
            }
        }

        function visibility(field) {
            var that = this;
            if (isFunction(field.visible)) { 
                return field.visible.call(that, props.model, field, that);
            }
            if (isNil(field.visible)) return true;
            return field.visible;

        }

        return {
            buttonClick,
            isInModel,
            onChanged,
            visibility,
            vueModel,
        }
    }
};
</script>
<template lang="pug">
.vueFormFieldMain
    .checkListField(:class="[schema.class, disabled === true ? 'fieldDisabled': '']")
        .form-group.row.gy-2.gx-3-align-items-left 
            .col-sm-12 
                label(
                    :for="id" 
                    v-if="schema.label && schema.label.length > 0"
                )  
                    |{{ schema.label }}
                    span.redAst(v-if="schema.required === true") *
        .fieldCheckList(:style="disabled === true ? 'opacity: 0.5; cursor:not-allowed': ''")
            .form-group.row.gy-2.gx-3-align-items-left.fieldCheckbox
                .field-wrap(:class="schema.buttons ? 'col-sm-9' : 'col-sm-12'")
                    .row.compStyle(
                        :class="schema.containerClass"
                        :style="[schema.inline === true ? `display: flex; flex-wrap: wrap; justify-content: ${schema.flexJustify};` : '', schema.overflow === true ? 'overflow:scroll' : '']"
                    )
                        //- Automatic Sort
                        template(v-if="schema.automaticSort === true")
                            template(v-for="item, index in schema.values")
                                div(
                                    v-if="model[schema.model].includes(item.id)"
                                    :class="schema.inline === true ? `${schema.size}` : 'col-12'" 
                                )
                                    input(
                                        type="checkbox" 
                                        :checked="isInModel(item.id) === true ? true : false"
                                        :id="`${id}_${index}`"
                                        :name="schema.model"
                                        :style="disabled === true ? `pointer-events:none; display:${schema.boxInput}`: `display:${schema.boxInput}`"
                                        :value="item.id" 
                                        @change="onChanged($event, item)"
                                    ) 
                                    label.smallLabel.d-flex.justify-content-start(
                                        :for="`${id}_${index}`"
                                        :style="disabled === true ? 'pointer-events:none': ''"
                                    ) 
                                        .col-auto
                                            span.squareBorder(
                                                :class="schema.borderClass" :style="`margin-right:${schema.marginBetween};position:relative; top:${schema.boxTop}px; font-size:${schema.boxFontSize}; border: ${schema.boxBorder}; border-radius:${schema.boxBorderRadius}px;padding:${schema.boxPadding};background:${schema.boxBackground};color:${schema.colorContent};`"
                                                v-if="schema.checkBoxType !== 'custom'"
                                            )
                                                font-awesome-icon(v-if="schema.checkBoxType === 'squareRound'" icon="fa-solid fa-square")
                                                font-awesome-icon(v-if="schema.checkBoxType === 'squareAngular'" icon="fa-solid fa-square-full")
                                                font-awesome-icon(v-if="schema.checkBoxType === 'squareHook'" icon="fa-solid fa-check")
                                                font-awesome-icon(v-if="schema.checkBoxType === 'squareCross'" icon="fa-solid fa-xmark")
                                        div(:class="schema.checkBoxText")  {{ item.name }}
                            hr
                            template(v-for="item, index in schema.values")
                                div(:class="schema.inline === true ? `${schema.size}` : 'col-12'" v-if="!model[schema.model].includes(item.id)")
                                    input(
                                        type="checkbox" 
                                        :checked="isInModel(item.id) === true ? true : false"
                                        :id="`${id}_${index}`"
                                        :name="schema.model"
                                        :style="disabled === true ? `pointer-events:none; display:${schema.boxInput}`: `display:${schema.boxInput}`"
                                        :value="item.id" 
                                        @change="onChanged($event, item)"
                                    ) 
                                    label.radioStyle.smallLabel.d-flex.justify-content-start(
                                        :for="`${id}_${index}`"
                                        :style="disabled === true ? 'pointer-events:none' : ''" 
                                    ) 
                                        .col-auto
                                            span.squareBorder(
                                                :class="schema.borderClass" :style="`margin-right:${schema.marginBetween};position:relative; top:${schema.boxTop}px; font-size:${schema.boxFontSize}; border: ${schema.boxBorder}; border-radius:${schema.boxBorderRadius}px;padding:${schema.boxPadding};background:${schema.boxBackground};color:${schema.colorContent};`"
                                                v-if="schema.checkBoxType !== 'custom'"
                                            )
                                                font-awesome-icon(v-if="schema.checkBoxType === 'squareRound'" icon="fa-solid fa-square" style="opacity:0")
                                                font-awesome-icon(v-if="schema.checkBoxType === 'squareAngular'" icon="fa-solid fa-square-full" style="opacity:0")
                                                font-awesome-icon(v-if="schema.checkBoxType === 'squareHook'" icon="fa-solid fa-check" style="opacity:0")
                                                font-awesome-icon(v-if="schema.checkBoxType === 'squareCross'" icon="fa-solid fa-xmark" style="opacity:0")
                                        div(:class="schema.checkBoxText")  {{ item.name }}
                        //- without automatic sort
                        template(v-if="schema.automaticSort === false")
                            div(:class="schema.inline === true ? `${schema.size}` : 'col-12'" v-for="item, index in schema.values")
                                input(
                                    type="checkbox" 
                                    :value="item.id" 
                                    :id="`${id}_${index}`"
                                    @change="onChanged($event, item)"
                                    :name="schema.model"
                                    :checked="isInModel(item.id) === true ? true : false" 
                                    :style="[disabled === true ? 'pointer-events:none' : '', 'display:none']" 
                                )
                                label.radioStyle.smallLabel.d-flex.justify-content-start(
                                    :for="`${id}_${index}`"
                                    :style="disabled === true ? 'pointer-events:none' : ''" 
                                ) 
                                    .col-auto
                                        span.squareBorder(
                                            :class="schema.borderClass" :style="`margin-right:${schema.marginBetween};position:relative; top:${schema.boxTop}px; font-size:${schema.boxFontSize}; border: ${schema.boxBorder}; border-radius:${schema.boxBorderRadius}px;padding:${schema.boxPadding};background:${schema.boxBackground};color:${schema.colorContent};`"
                                            v-if="schema.checkBoxType !== 'custom'"
                                        )
                                            font-awesome-icon(v-if="schema.checkBoxType === 'squareRound'" icon="fa-solid fa-square" :style="[isInModel(item.id) === false ? 'opacity:0' : '']")
                                            font-awesome-icon(v-if="schema.checkBoxType === 'squareAngular'" icon="fa-solid fa-square-full" :style="[isInModel(item.id) === false ? 'opacity:0' : '']")
                                            font-awesome-icon(v-if="schema.checkBoxType === 'squareHook'" icon="fa-solid fa-check" :style="[isInModel(item.id) === false ? 'opacity:0' : '']")
                                            font-awesome-icon(v-if="schema.checkBoxType === 'squareCross'" icon="fa-solid fa-xmark" :style="[isInModel(item.id) === false ? 'opacity:0' : '']")
                                    div(:class="schema.checkBoxText")  {{ item.name }}
                .col-sm-3(v-if="(schema.buttons && schema.buttons.type === 'text') && visibility(schema.buttons) === true")
                    button(
                        v-if="schema.buttons.onclick" 
                        @click="buttonClick(schema.buttons.onclick)" 
                        :class="schema.buttons.class"
                        :style="disabled === true ? 'pointer-events:none' : ''" 
                    )
                        | {{ schema.buttons.text }}
                    button(
                        v-if="!schema.buttons.onclick"  
                        :class="schema.buttons.class"
                        :style="disabled === true ? 'pointer-events:none' : ''" 
                    )
                        | {{ schema.buttons.text }}
            .hint(v-if="hinted && hinted.length > 0" v-html="hinted")
            .vueFormSmall.labelred(v-if="schema.errorShow === true")
                font-awesome-icon(icon="fa-solid fa-exclamation" class="errorExclamationMarkColor") 
                | &nbsp;{{ schema.errorText[0] }}
</template>